export default __webpack_public_path__ + "static-json/ne_50m_admin_0_countries_lakes-deb9e50ed90a8a10b97984841d93d39a.json";